import styled from 'styled-components'

export const CellContainer = styled.div`
  padding: 12px;
  min-height: 100px;
  transition: background-color 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EmptyMessage = styled.div`
  color: #999;
  font-style: italic;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 60px;
`;